import React, { useEffect, useState } from 'react';
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Grid,
  MenuItem,
  Select,
  FormControl,
  FormLabel,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchOfficesAsync } from '../../slices/officesSlice.js';
import SignupApi from '../../api/signup/signup.ts';
import { UserCreateErrorAlert, UserCreateSuccessAlert } from '../alert/userAlert.js';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const Signup = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const offices = useSelector((state) => state.offices.data);
  const cities = useSelector((state) => state.cities.data);
  const typeUser = useSelector((state) => state.typeUser.data);

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [formData, setFormData] = useState({
    document: '',
    name: '',
    email: '',
    phone: '',
    date_birth: '',
    gender: '',
    type_user: '',
    type_data: 8,
    office_id: '',
    city_id: '',
    password: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;

    if (name === 'office_id') {

      const selectedOffice = offices.find((o) => o.id_office === value);

      setFormData((prev) => ({
        ...prev,
        office_id: value,
        city_id: selectedOffice ? selectedOffice.city_id : '',
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData({
      document: formData.document,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      date_birth: formData.date_birth,
      gender: formData.gender,
      type_user: formData.type_user,
      type_data: formData.type_data,
      office_id: formData.office_id,
      city_id: formData.city_id,
      password: password,
    });

    const response = await SignupApi(formData);

    if (response.status == 200) {
      onClose();
      UserCreateSuccessAlert();
    }
    else {
      UserCreateErrorAlert();
    }

  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h5" component="h2" gutterBottom textAlign="center" mb={3}>
          Registro de Nuevo Usuario
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2.5}>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Nombre completo *</FormLabel>
              <TextField name="name" value={formData.name} onChange={handleChange} fullWidth error={!!errors.name} helperText={errors.name} />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Número de documento *</FormLabel>
              <TextField name="document" value={formData.document} onChange={handleChange} fullWidth error={!!errors.document} helperText={errors.document} />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Tipo de usuario *</FormLabel>
              <FormControl fullWidth error={!!errors.type_user}>
                <Select name="type_user" value={formData.type_user} onChange={handleSelectChange}>
                  <MenuItem value="">Seleccione...</MenuItem>
                  {typeUser.map((type) => (
                    <MenuItem key={type.id_type} value={type.id_type}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.type_user && <Typography color="error" variant="caption">{errors.type_user}</Typography>}
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Género *</FormLabel>
              <FormControl fullWidth error={!!errors.gender}>
                <Select name="gender" value={formData.gender} onChange={handleSelectChange}>
                  <MenuItem value="">Seleccione...</MenuItem>
                  <MenuItem value="Masculino">Masculino</MenuItem>
                  <MenuItem value="Femenino">Femenino</MenuItem>
                </Select>
                {errors.gender && <Typography color="error" variant="caption">{errors.gender}</Typography>}
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Fecha de nacimiento *</FormLabel>
              <TextField name="date_birth" type="date" value={formData.date_birth} onChange={handleChange} fullWidth error={!!errors.date_birth} helperText={errors.date_birth} InputLabelProps={{ shrink: true }} />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Teléfono</FormLabel>
              <TextField name="phone" value={formData.phone} onChange={handleChange} fullWidth />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Correo electrónico *</FormLabel>
              <TextField name="email" type="email" value={formData.email} onChange={handleChange} fullWidth error={!!errors.email} helperText={errors.email} />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel>Oficina *</FormLabel>
              <FormControl fullWidth error={!!errors.office_id}>
                <Select name="office_id" value={formData.office_id} onChange={handleSelectChange}>
                  <MenuItem key={0} value={0}>Seleccione...</MenuItem>
                  {/* en este campo necesito llevar el id de la oficina y el id de la ciudad */}
                  {offices.map((office) => (
                    <MenuItem key={office.id_office} value={office.id_office} >
                      {cities.find((city) => city.id_city === office.city_id)?.city_name + ' - ' + office.office_name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.office_id && <Typography color="error" variant="caption">{errors.office_id}</Typography>}
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <FormLabel htmlFor="outlined-password-input" sx={{ mb: 1, display: 'block', mt: 2, fontSize: 20 }}>
                Contraseña
              </FormLabel>
              <TextField
                required
                fullWidth
                id="outlined-password-input"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                margin="normal"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={showPassword ? 'ocultar contraseña' : 'mostrar contraseña'}
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

          </Grid>

          <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button variant="outlined" onClick={onClose}>Cancelar</Button>
            <Button type="submit" variant="contained" color="primary">Registrarse</Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default Signup;